(() => {
  function initialize(root = document) {
    if (root.querySelector('.rf-hero')) document.body.classList.add('rf-home');

    root.querySelectorAll('.rf-products:not([data-rf-ready])').forEach((section) => {
      section.dataset.rfReady = 'true';
      const track = section.querySelector('[data-rf-track]');
      section.querySelectorAll('[data-rf-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!track) return;
          const direction = Number(button.dataset.rfScroll || 1);
          track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });

    root.querySelectorAll('[data-rf-video]:not([data-rf-ready])').forEach((button) => {
      button.dataset.rfReady = 'true';
      button.addEventListener('click', () => {
        const video = button.closest('.rf-hero')?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.play();
          button.textContent = 'Pause';
          button.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          button.textContent = 'Play';
          button.setAttribute('aria-label', 'Play video');
        }
      });
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
